export default {

    /*  需要添加
    mounted() {
            this.qywxWebLogHandler();
    },
     */
    methods: {
        qywxWebLogHandler() {
            const vm = this;
            if (this.$organization.wx_redirect && this.$route.query.code && this.$route.query.state) {// read user info
                this.$api('Wechat.QYWeb' + '?code=' + this.$route.query.code + '&state=' + this.$route.query.state, null).then(res => {

                    if (res.data.success) {
                        vm.setUserInfo(res.data.data);
                        vm.$router.replace("/");
                    } else {
                        let msg = '错误的企业微信返回信息,请用其他方式登录!';
                        if (res.data.text && res.data.text != 'INVALID') msg = res.data.text;
                        vm.$messageBox.error(msg);
                        vm.$router.replace("/sign-in");
                        vm.ready = true;
                    }
                });
            } else if (this.$organization.oauth) {
                if (this.$route.query.code && this.$route.query.state && this.$route.query.state === 'zoom') {
                    this.$api('OAuth', {code: this.$route.query.code}).then(res => {
                        if (res.data.success) {
                            if (res.data.data.error) {
                                this.show_login_error = true;
                                this.error_message = res.data.data.message;
                            } else {
                                vm.setUserInfo(res.data.data);
                                vm.$router.replace("/");
                            }
                        } else {
                            this.$messageBox.error(res.data.text).then(() => {
                                this.jumpToSignIn()
                            }).catch(() => {
                                this.jumpToSignIn();
                            })
                        }
                    });
                } else {
                    this.ready = true;
                }
            } else {
                this.ready = true;
            }
        },
        qywxHandler() {
            const vm = this;
            if (this.$isWechat() && this.$organization.wx_redirect) { // 微信客户端
                this.$api('Wechat.QY', {code: this.$route.query.code, state: this.$route.query.state}, 1)
                    .then(res => {
                        const ret = res.data.data;
                        if (ret.redirect) { // 跳转去微信认证
                            window.location.href = ret.redirect;
                        } else if (ret.user) { // 已经登录了，则进入
                            //vm.$messageBox.error('Has User');
                            vm.setUserInfo(ret.user);
                            vm.$router.replace("/");
                        } else {// 如果都不行，则进行网络登录
                            //vm.$messageBox.error('微信登录失败，请正常登录!');
                            this.ready = true;
                        }
                    })
                    .catch(() => {
                        this.ready = true;
                    });
            } else {
                this.ready = true;
            }
        },
        jumpToWechatCorp() {
            window.location.href = this.$organization.wx_redirect;
        },
    }
}
